export function createEndpoint(baseEndpoint, ...args) {
  return [baseEndpoint, ...args].join("/")
}
